import { useState } from "react";
import { Box, Grid, TextField, Typography, FormControl } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";
import StatusSelect from "./Selects/StatusSelect";
import ScopeMultiSelect from "./Selects/ScopeMultiSelect";
import AssignedUsers from "./Users/AssignedUsers";

const RoleForm = ({
  errors,
  input,
  handleInputChange,
  handleStatusChange,
  status,
  disabled,
  scopes,
  idNumber,
  users,
  handleScopeChange,
  selectedScopes,
}) => {
  const [searchedUser, setSearchedUser] = useState<string>("");

  return (
    <>
      {idNumber ? (
        <Box component="form" mb={3}>
          <Grid container spacing={2} mb={4} display="flex" alignItems="flex-end">
            <Grid size={{ md: 5 }}>
              <TextField
                fullWidth
                id="roleName"
                name="name"
                label={intl.get("roleForm.name")}
                placeholder={intl.get("roleForm.placeholder.name")}
                value={input?.name}
                onChange={handleInputChange}
                disabled={disabled}
                error={Boolean(errors.name)}
                helperText={errors.name || ""}
              />
            </Grid>

            <Grid size={{ md: 5 }}>
              <TextField
                fullWidth
                id="roleDescription"
                name="description"
                label={intl.get("roleForm.description")}
                placeholder={intl.get("roleForm.placeholder.description")}
                value={input?.description}
                onChange={handleInputChange}
                disabled={disabled}
              />
            </Grid>

            <Grid size={{ md: 2 }}>
              <FormControl fullWidth>
                <StatusSelect
                  handleStatusChange={handleStatusChange}
                  selectedStatus={input.idActive}
                  status={status}
                  disabled={disabled}
                  defaultValue={false}
                  isClearable={false}
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2} display="flex" alignItems="flex-start">
            <Grid size={{ md: 6 }}>
              <Typography variant="subtitle1" mb={1}>
                {intl.get("roleForm.assignment.title")}
              </Typography>
              <Typography variant="body2" mb={2}>
                {intl.get("roleForm.assignment.message")}
              </Typography>
              <ScopeMultiSelect
                handleScopeChange={handleScopeChange}
                selectedScopes={selectedScopes}
                scopes={scopes}
                disabled={disabled}
              />
            </Grid>

            <Grid size={{ md: 6 }}>
              <Typography variant="subtitle1" mb={1}>
                {intl.get("roleForm.userAssignment.title")}
              </Typography>
              <Typography variant="body2" mb={2}>
                {intl.get("roleForm.userAssignment.message")}
              </Typography>
              <AssignedUsers
                users={users}
                idNumber={idNumber}
                searchedUser={searchedUser}
                setSearchedUser={setSearchedUser}
              />
            </Grid>
          </Grid>
        </Box>

      ) : (
        <Box component="form" mb={3}>
          <Grid container spacing={2}>
            <Grid size={12}>
              <TextField
                fullWidth
                id="roleName"
                name="name"
                label={intl.get("roleForm.name")}
                placeholder={intl.get("roleForm.placeholder.name")}
                value={input?.name}
                onChange={handleInputChange}
                disabled={disabled}
                error={Boolean(errors.name)}
                helperText={errors.name || ""}
              />
            </Grid>

            <Grid mt={3} size={12}>
              <TextField
                fullWidth
                id="roleDescription"
                name="description"
                label={intl.get("roleForm.description")}
                placeholder={intl.get("roleForm.placeholder.description")}
                value={input?.description}
                onChange={handleInputChange}
                disabled={disabled}
              />
            </Grid>

            <Grid mt={3} size={12}>
              <FormControl fullWidth>
                <StatusSelect
                  handleStatusChange={handleStatusChange}
                  selectedStatus={input.idActive}
                  status={status}
                  disabled={disabled}
                  defaultValue={false}
                  isClearable={false}
                />
              </FormControl>
            </Grid>

            <Grid mt={5} size={12}>
              <Typography variant="subtitle1" mb={1}>
                {intl.get("roleForm.assignment.title")}
              </Typography>
              <Typography variant="body2" mb={2}>
                {intl.get("roleForm.assignment.message")}
              </Typography>
              <ScopeMultiSelect
                handleScopeChange={handleScopeChange}
                selectedScopes={selectedScopes}
                scopes={scopes}
                disabled={disabled}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default RoleForm;
